Logger = require 'debug/logger'

module.exports = Logger.log.bind(Logger)



// WEBPACK FOOTER //
// ./app/scripts/debug/log.coffee